import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from 'src/app/services/invoice.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { WorkshopJobcardQuoteService } from '../workshop-jobcard-quote.service';

@Component({
  selector: 'app-workshop-jobcard-create-special-order',
  templateUrl: './workshop-jobcard-create-special-order.component.html',
  styleUrls: ['./workshop-jobcard-create-special-order.component.scss']
})
export class WorkshopJobcardCreateSpecialOrderComponent {

  @Input() public jobcard: any = {};
  @Input() public vatInclusive: boolean = false;
  @Input() public currencySymbol: string = '';
  @Input() public partnerData: any = {};
  @Input() public useWorkOrdersForWorkshop: boolean = false;

  public lineItems: any[] = [];
  public globalSelected: boolean = false;
  public specialOrderItems: any[] = [];
  public popupWindow: Window | null = null;
  public sendingToPOS : boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private workshopJobcardQuoteService: WorkshopJobcardQuoteService
  ) { }

  ngOnInit() {
    this.lineItems = JSON.parse(JSON.stringify(this.jobcard.quote.lineItems));
  }

  globalSelection(event) {
    //this.lineItems.forEach(item => item.selected = this.globalSelected && item.OutOfStock && item.SpecialOrderStatus === null);
    this.lineItems.forEach(item => item.selected = this.globalSelected && item.SpecialOrderStatus === null);
  }

  getSelectedCount() {
    return this.lineItems?.filter(item => item.selected).length || 0;
  }

  createSpecialOrder() {
    this.specialOrderItems = this.lineItems.filter((x) => {
      return x.selected;
    }).map((x) => {
      return x.ID;
    });
    this.sendingToPOS = true;
    this.workshopJobcardQuoteService.sendQuoteToPOS(
      this.jobcard,
      this.partnerData,
      this.specialOrderItems,
      false,
      () => { },
      () => {


        this.sendingToPOS = false;
        this.activeModal.close({sentToPOS: true});
      },
      null,
      this.useWorkOrdersForWorkshop
    ).subscribe(invoice=>{
      console.log('SO Invoice updated', invoice);
    });

  }

}
